import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { theme } from 'pfm-ui-components';
import { AppProps } from 'next/app';
import Font from '../styles/fonts';
import GlobalStyle from '../styles/global';
import Header from '../components/common/Header';
import { CookiesProvider, Cookies } from 'react-cookie';
import { initAxios } from '../API/axios';
import { removeHttpAndHttpsProtocolFromString, setAuthToken } from '../API/utils';
import { AppWrapper } from '../store';
import AppComponentWrapper from '../components/common/AppComponentWrapper';
import { CHANNEL_ID, CHANNEL_ID_TYPES, CUSTOMER_ID, TOKEN } from '../constants/common';
import GTM from '../GTM';
import ErrorBoundary from '../components/common/ErrorBoundary';

interface MyAppState {
  customerId: string | null;
  channelId: string | null;
  isEncryptionScriptLoaded: boolean;
  showHeader: boolean;
  lastClickTime: Date;
}

class MyApp extends React.Component<AppProps, MyAppState> {
  constructor(props: AppProps) {
    super(props);
    initAxios();
    const cookies = new Cookies();
    this.state = {
      customerId: typeof window === 'undefined' ? null : cookies.get(CUSTOMER_ID),
      channelId: typeof window === 'undefined' ? null : cookies.get(CHANNEL_ID),
      isEncryptionScriptLoaded: false,
      showHeader: cookies.get(CHANNEL_ID) !== CHANNEL_ID_TYPES.MBK, // Do not show header for MBK channel ID in the whole app
      lastClickTime: new Date(),
    };
    if (typeof window !== 'undefined') {
      // if (document.referrer) {
      // const referrer = document.referrer;
      // const withoutHttpHttps = removeHttpAndHttpsProtocolFromString(referrer);
      // Fetch only the host part i.e localhost:3001
      // const refHost = withoutHttpHttps.split('/')[0];
      // console.log('referrer refhost pfm',referrer,refHost,process.env.PFM_HOST)

      // if (refHost === process.env.PFM_HOST) {
      setAuthToken(cookies.get(TOKEN));
      // }
      // }
      // load encryption script
      const script = document.createElement('script');
      script.src = '/jsencrypt.min.js';
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        this.onScriptLoad();
      };
    }
  }

  onScriptLoad = () => {
    this.setState({ isEncryptionScriptLoaded: true });
  };

  componentDidMount() {
    // Restrict user from doing right click, copy and pasting in the application
    document.addEventListener('contextmenu', this._handleUserActions);
    document.addEventListener('copy', this._handleUserActions);
    document.addEventListener('paste', this._handleUserActions);

    // gtm layer initialising
    GTM.initialise();
  }

  componentWillUnmount() {
    document.removeEventListener('contextmenu', this._handleUserActions);
    document.removeEventListener('copy', this._handleUserActions);
    document.removeEventListener('paste', this._handleUserActions);
  }

  _handleUserActions = (event) => {
    event.preventDefault();
  };

  keepSessionAlive() {
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      window.open('invoke:keepSessionAlive');
    } else if (navigator.userAgent.match(/Android/i)) {
      AxisApp.keepSessionAlive();
    }
  }

  keepActiveSessionOnMBK = (chennalID, isLoginPage) => {
    const currentTime = new Date();
    const { lastClickTime } = this.state;
    if (!isLoginPage && chennalID == CHANNEL_ID_TYPES.MBK) {
      if (lastClickTime && currentTime.getTime() - lastClickTime.getTime() > 2 * 60 * 1000) {
        this.setState({ lastClickTime: currentTime });
        this.keepSessionAlive();
      }
    }
  };

  render() {
    const { Component, pageProps } = this.props;
    const isLoginPage = pageProps && pageProps.loginPage;
    const cookies = new Cookies();
    const showHead = cookies.get(CHANNEL_ID) !== CHANNEL_ID_TYPES.MBK;
    const chennalID = cookies.get(CHANNEL_ID);
    return typeof window === 'undefined' ? null : (
      <>
        <head>
          {/* This meta tag is used to restrict user from zomming in into the website */}
          <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
        </head>
        <CookiesProvider>
          <AppWrapper customerId={this.state.customerId} channelId={this.state.channelId} showHeader={showHead}>
            <ThemeProvider theme={theme}>
              <title>Axis Bank</title>
              <Font />
              <GlobalStyle />
              <Layout onClick={() => this.keepActiveSessionOnMBK(chennalID, isLoginPage)}>
                <AppComponentWrapper
                  hasFooter={!isLoginPage}
                  hasHeader={showHead && !isLoginPage}
                  showHeader={showHead}
                >
                  {showHead && <Header loginHeader={isLoginPage} />}
                  <ErrorBoundary>{this.state.isEncryptionScriptLoaded && <Component {...pageProps} />}</ErrorBoundary>
                </AppComponentWrapper>
              </Layout>
            </ThemeProvider>
          </AppWrapper>
        </CookiesProvider>
      </>
    );
  }
}

const Layout = styled.div`
  width: 100%;
`;

export default MyApp;
